<div class="container-fluid dashboard">
  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header bg-primary text-white">
          <h4 class="mb-0">
            <i class="fa fa-tachometer-alt me-2"></i>Dashboard
          </h4>
        </div>
        <div class="card-body">
          <div class="welcome-section text-center py-5">
            <div class="mb-4">
              <i class="fa fa-check-circle text-success" style="font-size: 4rem;"></i>
            </div>
            <h2 class="mb-3">Welcome to ShiftClock v2!</h2>
            <p class="lead text-muted mb-4">You have successfully logged in.</p>
            <div class="user-info">
              <p class="mb-2"><strong>User:</strong> {{ currentUser?.fullName || currentUser?.userName }}</p>
              <p class="mb-2"><strong>Email:</strong> {{ currentUser?.emailAddress }}</p>
              <p class="mb-4" *ngIf="currentUser?.isSuperAdmin">
                <span class="badge bg-danger">Super Admin</span>
              </p>
            </div>
            <div class="alert alert-info mt-4" role="alert">
              <i class="fa fa-info-circle me-2"></i>
              <strong>Authentication Successful!</strong> The API integration is working correctly.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-4">
      <div class="card text-center">
        <div class="card-body">
          <i class="fa fa-users text-primary" style="font-size: 3rem;"></i>
          <h5 class="card-title mt-3">Employees</h5>
          <p class="card-text">Manage employee records and information</p>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card text-center">
        <div class="card-body">
          <i class="fa fa-calendar text-success" style="font-size: 3rem;"></i>
          <h5 class="card-title mt-3">Scheduling</h5>
          <p class="card-text">View and manage shift schedules</p>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card text-center">
        <div class="card-body">
          <i class="fa fa-clock text-warning" style="font-size: 3rem;"></i>
          <h5 class="card-title mt-3">Time Tracking</h5>
          <p class="card-text">Track attendance and working hours</p>
        </div>
      </div>
    </div>
  </div>
</div>
